import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

function Layout() {
  const location = useLocation();

  const isActive = (path: string): boolean => location.pathname === path;

  return (
    <div className="app-shell">
      <header className="site-header">
        <nav className="navbar">
          <Link to="/" className="brand">
            <span className="brand-main">@flo8998</span>
            <span className="brand-sub">Portfolio & Projekte</span>
          </Link>

          <div className="nav-links">
            <Link className={isActive("/") ? "active" : ""} to="/">
              Home
            </Link>

            <Link className={isActive("/about") ? "active" : ""} to="/about">
              Über mich
            </Link>

            <Link
              className={isActive("/projects") ? "active" : ""}
              to="/projects"
            >
              Projekte
            </Link>

            <Link
              className={isActive("/terminal") ? "active" : ""}
              to="/terminal"
            >
              Terminal
            </Link>

            <Link
              className={isActive("/spotify") ? "active" : ""}
              to="/spotify"
            >
              Spotify
            </Link>

            <Link
              className={isActive("/contact") ? "active" : ""}
              to="/contact"
            >
              Kontakt
            </Link>
          </div>
        </nav>
      </header>

      <main className="page-container">
        <Outlet />
      </main>

      <footer className="site-footer">
        <p>
          © {new Date().getFullYear()} Florian (@flo8998) — built with React +
          TypeScript
        </p>
      </footer>
    </div>
  );
}

export default Layout;
